<div class="flex flex-column align-items-start">
  @if (reportSettings$ | async; as reportSettings) {
    <div class="mt-3">
      @for (setting of settingsConfig; track setting.key) {
        <div>
          {{ setting.label }}:
          <span class="subtitle3Font">
            {{ reportSettings[setting.key] ? 'On' : 'Off' }}
          </span>
        </div>
      }
    </div>
  }

  <div class="flex align-items-center justify-content-center w-full mt-5">
    <p-button (onClick)="cancel()"
              styleClass="p-button-outlined"
              class="mr-5"
              label="Cancel"
              i18n-label>
    </p-button>

    <p-button (onClick)="checkForPlagiarism()"
              [disabled]="requestInProcess"
              label="Confirm and Check"
              i18n-label>
    </p-button>
  </div>
</div>